import React from 'react';
import styles from './Table.module.css';

const Table = ({ tableTitles, rows, onClick }) => {
    return (
        <div className={styles.table}>
            <div className={styles.header}>
                {tableTitles.map((title, index) => (
                    <div key={index} className={styles.headerCell}>
                        {title}
                    </div>
                ))}
            </div>
            <div className={styles.body}>
                {rows?.length > 0 && rows.map((row, rowIndex) => (
                    <div key={rowIndex} className={styles.row} onClick={() => onClick(rowIndex)}>
                        {row.map((cell, cellIndex) => (
                            <div key={cellIndex} className={styles.cell}>
                                {cell}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Table;